import React, { useRef, useState, useMemo } from 'react';
import {
  Card, Col, Form, Row, Button
} from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import Calendar from 'react-calendar';
import style from './TabResults.module.less';
import FileInput, { FileView } from '../../../UI/upload/FileInput';
// import styleCommon from "../../../../../style/common.less";
import { monthsArray } from '../../../../stores/StratProject/StrategyStore';
import '../../../../../style/Calendar.less';
import { useOutsideBounder } from '../../../../hooks/useOutsideClick';
import StatusBadge from '../../../common/StatusBadge';
import { status } from '../../../../helpers/StrategyProject/stratProjectHelpers';
import ConfirmModal from '../../../common/ConfirmModal';
import TooltippedElement from '../../../common/TooltippedElement';
import { isAdmin } from "../../../../services/rolesSvc";
import Select from 'react-select';
import Required from '../../../Required';
import { years } from '../../../../helpers';
import YearSelect from '../../../common/YearSelect';
import { PlusLg } from 'react-bootstrap-icons';
import PersonsInChargeModal from './PersonsInChargeModal';
import ImpactProjectsModal from './ImpactProjectsModal';
import { getName } from '../../../../helpers/passport';
import { observer } from 'mobx-react';
import { useStore } from '../../../../stores/StoreHelpers';
import {ProjectsFacts} from './ProjectsFacts';
import MilestoneDocumentsModal from './MilestoneDocumentsModal';
import MilestoneFilesModal from '../../../project/PassportRead/MilestoneFilesModal';
import { filterPersonWithProjects } from '../../../../helpers/StrategyProject/stratProjectHelpers';

export const MileStoneEdit = observer(({
  edit, index, options, onChange, value, onDelete, onDeleteFile, userCtx, blocked, projects, closedPeriods
}) => {
  const dateRef = useRef(null);
  const store = useStore();
  const [activeMilestone, setActiveMilestone] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [personsInChargeModalShow, setPersonInChargeModalShow] = useState(false);
  const [impactProjectsModalShow, setImpactProjectsModalShow] = useState(false);
  const projectDisabledStatus = (() => {
    if (isAdmin(userCtx)) return false;
    return (value.status === status.approved || value.status === status.onProjOffice || value.status === status.declined);
  })();
  useOutsideBounder(dateRef);

  const monthsOptions = useMemo(() => monthsArray.map(((month, i) => ({value: i, label: month}))), [])
  const disabled = useMemo(() => (closedPeriods || []).includes(value.yearPlan), [closedPeriods])

  return (
    <Card className={style.rowResult}>
      <Card.Header className={style.header}>
        Веха
        {' '}
        {value.orderNum ?? index + 1}
        <div style={{ display: 'flex', gap: '20px' }}>
          <StatusBadge type="resultState" status={value.status ?? 'inProgress'} />
          {!edit && !disabled && (
            <div
              onClick={() => {
                (!!value.status && value.status !== 'isCreating') ? setConfirmModalOpen(!confirmModalOpen) : onDelete();
              }}
              className={style.closeButton}
            />
          )}
        </div>
      </Card.Header>
      <Card.Body>
        <Row className={style.rowResult}>
          <Form.Group as={Col}>
            <Form.Label data-required={edit ? 'false' : 'true'}>Название Вехи</Form.Label>
            <Form.Control disabled={edit || disabled} name="name" value={value.name} required onChange={(e) => onChange(e.target.value, value.id || value.key, e.target.name)} as="textarea" placeholder="Макс. 250 символов" />
          </Form.Group>
        </Row>
        <Row className={style.rowResult}>
          <Form.Group as={Col} xs={7}>
            <Form.Label>
              УГТ(план)
              <TooltippedElement iconSize="18px" tooltip="Уровень готовности технологии" />
            </Form.Label>
            {/* <Form.Control disabled={edit} name={`trlId`} value={value['trlId'] && options.ygt[+value['trlId']-1].id}  onChange={(e)=>onChange(+e.target.value || null,index,e.target.name)}  required as={'select'}> */}
            {/*    <option defaultChecked value={null} >Не указан</option> */}
            {/*    {options.ygt.map(elem=><option selected={Number(elem.id) === +value['trlId']} value={Number(elem.id)}>{elem.descr}</option>)} */}
            {/* </Form.Control> */}
            <div>
              {!edit && !disabled ? (
                  <AsyncSelect
                    value={value.trlId ? { value: options.ygt[value.trlId].id, label: options.ygt[value.trlId].descr } : { value: null, label: 'Не указано' }}
                    defaultOptions={options.ygt.map((elem) => ({
                      value: elem.id,
                      label: elem.descr,
                    }))}
                    // loadOptions={options.getOptions}
                    onChange={(e) => onChange(e.value, value.id || value.key, 'trlId')}
                  />
                )
                : <Form.Control disabled value={value.trlId ? options.ygt[value.trlId].descr : 'Не указано'} />}
            </div>
          </Form.Group>
          <Form.Group as={Col} xs={5}>
            <Form.Label>
              Дата выполнения (план) <Required />
            </Form.Label>
            <Row>
              <Col xs={5}>
                {edit || disabled ?
                  <Form.Control value={value.yearPlan} readOnly/> :
                  <YearSelect
                    year={value.yearPlan}
                    years={years.filter(year => year >= 2023 && !closedPeriods.includes(year))}
                    onChange={(year) => onChange(year.value, value.id || value.key, 'yearPlan')}
                  />
                }
              </Col>
              <Col xs={7}>
                {edit || disabled ? <Form.Control value={monthsArray[value.monthPlan]} readOnly/> :<Select
                  options={monthsOptions}
                  value={monthsOptions.find(
                    (opt, i) => i === value.monthPlan
                  )}
                  onChange={(month) => onChange(month.value, value.id || value.key, 'monthPlan')}
                  placeholder="Выберите месяц"
                />}
              </Col>
            </Row>
          </Form.Group>
        </Row>
        {edit
          && (
            <Row className={style.rowResult}>
              <Form.Group as={Col}>
                <Form.Label>
                  УГТ(Факт)
                  <TooltippedElement iconSize="18px" tooltip="Уровень готовности технологии" />
                </Form.Label>
                <div>
                  {!(projectDisabledStatus || blocked) ? (
                    <AsyncSelect
                      value={value.trlFactId ? { value: options.ygt[value.trlFactId].id, label: options.ygt[value.trlFactId].descr } : { value: null, label: 'Не указано' }}
                      defaultOptions={options.ygt.map((elem) => ({
                        value: elem.id,
                        label: elem.descr,
                      }))}
                      // loadOptions={options.getOptions}
                      onChange={(e) => onChange(e.value, value.id || value.key, 'trlFactId')}
                    />
                  ) : <Form.Control disabled value={value.trlFactId ? options.ygt[value.trlFactId].descr : 'Не указано'} />}
                </div>
              </Form.Group>
              <Form.Group as={Col} xs={5}>
                <Form.Label>
                  Дата выполнения (факт) <Required />
                </Form.Label>
                <Row>
                  <Col xs={5}>
                    {projectDisabledStatus || blocked ? <Form.Control value={value.yearFact || '-'} readOnly/> : <YearSelect year={value.yearFact} years={years} onChange={year => onChange(year.value, value.id || value.key, 'yearFact')} />}
                  </Col>
                  <Col xs={7}>
                    {projectDisabledStatus || blocked ?
                      <Form.Control readOnly value={monthsArray[value.monthFact] || '-'}/> :
                      <Select
                        options={monthsOptions}
                        value={monthsOptions.find(
                          (opt, i) => i === value.monthFact
                        )}
                        onChange={month => onChange(month.value, value.id || value.key, 'monthFact')}
                        placeholder='Выберите месяц'
                      />
                    }
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          )}
        <Row className={style.rowResult}>
          {(value.personsInCharge && value.personsInCharge.length > 0 || value.projs && value.projs.length > 0) &&
            <div className={style['personsinCharge']}>
              <h2 style={{textAlign: 'left', fontSize: 16, marginBottom: 8,  color: '#212529'}}>Ответственные за достижение:</h2>
              <ul className={style['personsInCharge-list']} style={{marginBottom: edit ? 0 : 24}}>
                {value.personsInCharge && value.personsInCharge.length > 0 && value.personsInCharge.filter(person => !person.projId).map((person) => <li className={style['personsInCharge-item']} key={person.id}>
                  {getName(person)}
                  {!edit && !disabled && <button
                    type='button'
                    className='btn-close'
                    style={{width: 13, height: 13, padding: 0}}
                    onClick={() => onChange(value.personsInCharge.filter((v) => v.id !== person.id), value.id || value.key, 'personsInCharge')}
                  />}
                </li>)}
                {value.projs && value.projs.length > 0 && value.projs.map(proj =>
                {
                  const project = projects.find((value) => value.originId === proj.originId)
                  return project && <li className={style['personsInCharge-item']} key={`proj-${project.originId}`}>
                    <p>
                      {project.fullNumber} {project.name} <span style={{color: '#7F7F7F', marginLeft: 16, marginRight: 16}}>{project?.head?.displayName} ({project?.head?.post})</span>
                      {!edit && !disabled && <button
                        className='btn-close'
                        type='button'
                        style={{width: 13, height: 13, padding: 0}}
                        onClick={() => {
                          onChange(value.projs.filter((v) => v.id !== proj.id), value.id || value.key, 'projs')
                          onChange(value.personsInCharge.filter(person => person.projId !== proj.id), value.id || value.key, 'personsInCharge')
                        }}
                      />}
                    </p>
                  </li>
                })
                }
              </ul>
            </div>
          }
          {!edit && <Col className='d-flex gap-3'>
            <Button
              variant='outline-primary'
              onClick={() => setPersonInChargeModalShow(true)}
              variant={value.projs.some(proj => proj.selected) ? 'outline-secondary' : 'outline-primary'}
              disabled={value.projs.some(proj => proj.selected) || disabled}
            >
              <PlusLg /> Назначить ответственного <Required />
            </Button>
            <Button
              onClick={() => setImpactProjectsModalShow(true)}
              variant={value.personsInCharge.some(person => person.selected) ? 'outline-secondary' : 'outline-primary'}
              disabled={value.personsInCharge.some(person => person.selected) || disabled}
            >
              <PlusLg /> Проекты, влияющие на выполнение вехи
            </Button>
            {((value.personsInCharge && !value.personsInCharge.every((person) => !person.selected)) ||
                (value.projs && !value.projs.every((project) => !project.selected))) &&
              <Button
                variant='outline-danger'
                onClick={() => {
                  const filteredProjects = value.projs.filter((project) => !project.selected)
                  onChange(filteredProjects, value.id || value.key, 'projs')
                  onChange(value.personsInCharge.filter((person) => !person.selected && (!person.projId || filteredProjects.some(proj => proj.id === person.projId))), value.id || value.key, 'personsInCharge')
                }}
                disabled={disabled}
              >
                Очистить текущий выбор
              </Button>}
          </Col>}
        </Row>
        {!edit && !disabled ? (
            <Row className={style.rowResult}>
              <Form.Group as={Col}>
                <Form.Label>Документы</Form.Label>
                <FileInput
                  downloadble
                  onDeleteFile={(id) => onDeleteFile(id, value?.id)}
                  fileList={value.files.filter((x) => x?.isPlan === true)}
                  onFileChange={(newFiles) => onChange([...value.files, ...newFiles], value.id || value.key, 'files')}
                  className={style.fileInputResults}
                />
              </Form.Group>
            </Row>
          )
          : (
            <Row className={style.rowResult}>
              <Form.Group as={Col}>
                <Form.Label>Документы</Form.Label>
                {value.files && value.files.filter((x) => x?.isPlan === true).map((x, y) => <FileView index={y} item={x} disabled isDownloadable />)}
              </Form.Group>
            </Row>
          )}
        {edit && <Row>
          <Form.Group as={Col} className='my-4'>
            <Form.Label>Описание выполнения вехи <Required/></Form.Label>
            <Form.Control
              as={'textarea'}
              disabled={projectDisabledStatus || blocked}
              style={{width: '100%'}}
              name='result'
              rows={4}
              defaultValue={
                value.result ||
                (
                  value.projMilestones && value.projMilestones.length > 0 ?
                    'В проектах, в которые назначена данная вехи, заполнены факты:\n' + value.projMilestones.filter(milestone => !!milestone.result).map((milestone, i) => `${milestone.projs[0].fullNumber}. ${milestone.result}`).join('\n') :
                    ''
                )
              }
              required
              onChange={(e) => {
                onChange(e.target.value, value.id || value.key, e.target.name)
              }}
            />
          </Form.Group>
          {value.projs?.length > 0 && value.projMilestones?.length > 0 && <Row className={style.projectFacts}>
            <h2>Фактическое значение по вехам проектов</h2>
            <ProjectsFacts activeMilestoneSetter={setActiveMilestone} projectFacts={value.projMilestones}/>
          </Row>}
        </Row>}
        {edit ? (!projectDisabledStatus && !blocked) ? (
          <Row className={style.rowResult}>
            <Form.Group as={Col}>
              <Form.Label>Подтверждающие результат документы</Form.Label>
              <FileInput
                downloadble
                onDeleteFile={(id) => onDeleteFile(id, value?.id)}
                fileList={value.files.filter((x) => x?.isPlan === false)}
                onFileChange={(newFiles) => onChange([...value.files, ...newFiles], value.id || value.key, 'files')}
                className={style.fileInputResults}
              />
            </Form.Group>
          </Row>
        ) : (
          <Row className={style.rowResult}>
            <Form.Label>Подтверждающие результат документы</Form.Label>
            <Form.Group as={Col}>
              {value.files && value.files.filter((x) => x?.isPlan === false).map((x, y) => <FileView index={y} item={x} isDownloadable disabled />)}
            </Form.Group>
          </Row>
        ) : <></>}
      </Card.Body>
      <ConfirmModal
        show={confirmModalOpen}
        onConfirm={() => onDelete()}
        onClose={() => setConfirmModalOpen(!confirmModalOpen)}
        message="Данная веха будет удалена. Вы уверены ?"
      />
      <PersonsInChargeModal
        show={personsInChargeModalShow}
        onHide={() => setPersonInChargeModalShow(false)}
        onSave={values => onChange(values, value.id || value.key, 'personsInCharge')}
        value={value}
      />
      <ImpactProjectsModal
        show={impactProjectsModalShow}
        onHide={() => setImpactProjectsModalShow(false)}
        onSave={values => {
          onChange(values, value.id || value.key, 'projs')
          onChange([
            ...value.personsInCharge.filter(person => {
              const filterValues = filterPersonWithProjects(person, values)
              return filterValues.inProjectsWithProjId || filterValues.notContainsWithoutProjId
            }),
            ...values.filter(value => value.selected).map(proj => ({...proj.head, projId: proj.id}))
          ], value.id || value.key, 'personsInCharge')
        }}
        value={value}
        projects={projects}
      />
      <MilestoneFilesModal
        show={!!activeMilestone}
        onHide={() => setActiveMilestone(null)}
        files={activeMilestone?.files || []}
      />
    </Card>
  );
})

export default MileStoneEdit;
